// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cui-button',
  templateUrl: 'cui-button.component.html',
  styleUrls: ['./cui-button.component.scss'],
})
export class CuiButtonComponent {
  @Input() type: 'primary' | 'secondary' | 'ternary' | 'full' | 'link' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() label = 'Button';
  @Input() disabled: boolean;
  @Input() iconName: string;

  @Output() buttonClicked = new EventEmitter<Event>();
}
